import mobileRefinementButton from './components/mobile-refinement-button';
import sortOptions from './components/sorting-options';
import totalResults from './components/total-results';

/**
 * @param {import('../../../type-definitions').SearchResult} result - Search result
 * @returns {string} sorting bar HTML
 */
export default result => {
    if (!result) {
        return '';
    }
    const {sortingOptions, numTotalResults, refinementsData} = result;

    return `
        ${
            sortingOptions
                ? `
                <div class="listing-options ${window.SitePreferences.SHOW_NEW_HEADER ? 'new-header' : ''}">
                    <div class="listing-options-display">
                        ${mobileRefinementButton(refinementsData.selectedRefinements.length)}
                        ${sortOptions(sortingOptions)}
                        ${totalResults(numTotalResults)}
                    </div>
                </div>
                `
                : ''
        }
    `;
};
